{
  "cms.editor.back": "Back",
  "cms.editor.cancel": "Cancel",
  "cms.editor.title": "Editor",
  "cms.editor.page.heading": "Edit page",
  "cms.editor.lockedDestination.state": "Locked state",
  "cms.editor.lockedDestination.description": "This destination is fixed and cannot be edited here.",
  "cms.editorPreviewSlot.placeholder.body": "Preview is not yet available.",
  "cms.editorPreviewSlot.title": "Preview",
  "cms.form.sidebarLink.error.labelRequired": "The top line is required.",
  "cms.form.sidebarLink.error.routeRequired": "Choose a route.",
  "cms.form.sidebarLink.error.subtitleRequired": "The bottom line is required.",
  "cms.form.sidebarLink.icon": "Icon",
  "cms.form.sidebarLink.iconNone": "No icon",
  "cms.form.sidebarLink.label": "Top line",
  "cms.form.sidebarLink.route": "Route",
  "cms.form.sidebarLink.routePlaceholder": "Choose a route",
  "cms.form.sidebarLink.subtitle": "Bottom line",
  "cms.form.sidebarLink.tab": "Home page tab",
  "cms.form.sidebarLink.tab.lakikaveri": "Lakikaveri",
  "cms.form.sidebarLink.tab.palvelut": "Membership & benefits",
  "cms.form.sidebarLink.targetKind": "Target",
  "cms.form.sidebarLink.targetKind.page": "Article",
  "cms.form.sidebarLink.targetKind.route": "Member route",
  "cms.publish.success": "Published to production.",
  "cms.saveDraft.success": "Draft saved."
}
